// extracted by mini-css-extract-plugin
module.exports = {"info":"styles_info__3cI3l"};